/* Component Dependencies */
var errorMessagesTemplate = require('templates/errorMessages-guestInfo.hbs');
var errorMessagesSignInTemplate = require('templates/errorMessages-signIn.hbs');
var errorMessagesMainTemplate = require('templates/errorMessages.hbs');
var errorMessagesResLookupFormTemplate = require('templates/errorMessages-resLookupForm.hbs');
var errorMessagesNavigationBarTemplate = require('templates/errorMessages-navigationBar.hbs');
var errorMessagesCommonTemplate = require('templates/errorMessages-common.hbs');
var errorMessagesSearchFormTemplate = require('templates/errorMessages-searchForm.hbs');
var errorMessagesRewardsFormTemplate = require('templates/errorMessages-rewardsForm.hbs');
var errorMessages800PageTemplate = require('templates/errorMessages-800Page.hbs');
var errorMessagesOverrideOverlayTemplate = require('templates/errorMessages-cancellationFeeOverrideOverlay.hbs');
var errorMessagesSearchRateProgramFormTemplate = require('templates/errorMessages-searchRateProgramForm.hbs');
var errorMessagesBillingCodeTemplate = require('templates/errorMessages-billingCode.hbs');
var errorMessagesGuestInfoFormTemplate = require('templates/errorMessages-guestInfoFormErrorMessages.hbs');
var errorMessagesListTemplate = require('templates/errorMessages-List.hbs');
var errorMessagesSNAUpgradeOptionsTemplate = require('templates/errorMessages-snaUpgradeOptionsErrorMessages.hbs');
var errorMessagesRoominglistTemplate = require('templates/errorMessages-roominglist.hbs');
var errorMessagesGroupSearchFormTemplate = require('templates/errorMessages-groupSearchForm.hbs');
var errorMessagesLegacyAccountMergeFlowTemplate = require('templates/errorMessages-legacyAccountMergeFlow.hbs');
var errorMessagesHsiaTemplate = require('templates/errorMessages-hsia.hbs');
var errorMessagesBulgariRLMPageTemplate = require('templates/errorMessages-bulgariRLMPage.hbs');
var errorMessagescheckInDetailsTemplate = require('templates/errorMessages-checkInDetails.hbs');
var errorMessagesOcjSignInTemplate = require('templates/errorMessages-ocjSignIn.hbs');
var errorMessagesUpdatedRoomTemplate = require('templates/errorMessages-updatedRoomPage.hbs');
var $ = require('jquery');


var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

PubSub.register(AriesComponent.extend({
  type: 'errorMessages',
  template: {
    'errorMessages-guestInfo': errorMessagesTemplate,
    'errorMessages': errorMessagesMainTemplate,
    'errorMessages-signIn': errorMessagesSignInTemplate,
    'errorMessages-navigationBar': errorMessagesNavigationBarTemplate,
    'errorMessages-common': errorMessagesCommonTemplate,
    'errorMessages-resLookupForm': errorMessagesResLookupFormTemplate,
    'errorMessages-searchForm': errorMessagesSearchFormTemplate,
    'errorMessages-rewardsForm': errorMessagesRewardsFormTemplate,
    'errorMessages-800Page': errorMessages800PageTemplate,
    'errorMessages-cancellationFeeOverrideOverlay': errorMessagesOverrideOverlayTemplate,
    'errorMessages-searchRateProgramForm': errorMessagesSearchRateProgramFormTemplate,
    'errorMessages-billingCode': errorMessagesBillingCodeTemplate,
    'errorMessages-guestInfoFormErrorMessages': errorMessagesGuestInfoFormTemplate,
  	'errorMessages-groupSearchForm': errorMessagesGroupSearchFormTemplate,
    'errorMessages-snaUpgradeOptionsErrorMessages': errorMessagesSNAUpgradeOptionsTemplate,
    'errorMessages-roominglist': errorMessagesRoominglistTemplate,
    'errorMessages-legacyAccountMergeFlow': errorMessagesLegacyAccountMergeFlowTemplate,
    'errorMessages-List': errorMessagesListTemplate,
    'errorMessages-hsia': errorMessagesHsiaTemplate,
    'errorMessages-bulgariRLMPage':errorMessagesBulgariRLMPageTemplate,
    'errorMessages-checkInDetails': errorMessagescheckInDetailsTemplate,
    'errorMessages-ocjSignIn': errorMessagesOcjSignInTemplate,
    'errorMessages-updatedRoomPage': errorMessagesUpdatedRoomTemplate
  },
  subscribe: {
    'ERRORMSG_REFRESH': 'refresh',
    'TOGGLE_ERROR_MESSAGE': 'toggleErrorMessages',
    'TARGETTED_ERRORMSG_REFRESH': 'targettedErrorMessages'
  },

  /**
    * This function is used to toggle the component state (show/hide)
    * @returns {Boolean} Operation Succeeded or not
    */
  toggleErrorMessages: function(showError) {
    if(showError){
      this.$el.show();
    } else {
      this.$el.hide();
    }
    return true;
  },
  targettedErrorMessages: function _targettedErrorMessages(context) {
    if (this.$el.data('message-identifier') === (context.errorMessageComponentId || context)) {
      this.refresh(context);
      return true;
    }
    return false;
  },
  /*
  * callback for after component refresh
  */
  afterComponentRefresh: function(data){
    if(data && data.housingRestrictedError) {
      this.$el.find('.js-housing-error').removeClass('is-hidden');
      this.$el.find('#form-action-messages').addClass('is-hidden');
    }
    else if(data && data.passKeyError) {
      this.$el.find('.js-passkey-error').removeClass('is-hidden');
      this.$el.find('#form-action-messages').addClass('is-hidden');
      if(data && data.errorMessageTitle) {
        this.$el.find('.js-passkey-title').removeClass('is-hidden');
      }
    }
    if (this.$el.data('message-identifier') === 'callerTypeErrorMessage') {
      this.pubsub.publish('CALLERTYPE_NAVBAR_REFRESH');
    } else if (this.$el.data('message-identifier') === 'travelPlannerErrorMessages') {
      this.pubsub.publish('TRAVEL_PLANNER_NAVBAR_REFRESH');
    } else if (this.$el.data('message-identifier') === 'groupAvailabilityErrorMessage') {
      this.pubsub.publish('HIDE_HOUSING_RESTRICTED_WARNING_MESSAGE');
    }
  },

  bindEvents: function() {
    var _self = this,$window = $(window);
    $window.on('load', function (event) {
    	if($(".tile-error-messages").is(":visible")){
    	   _self.pubsub.publish("HIDESUCCESS",[true]);	
      }
    });
    this.toggleErrorMessageContainer();
    if (this.$el.data('message-identifier') === 'groupAvailabilityErrorMessage') {
      this.pubsub.publish('HIDE_HOUSING_RESTRICTED_WARNING_MESSAGE');
    }
  },

  toggleErrorMessageContainer: function _toggleErrorMessageContainer() {
    var _self = this;
    if (_self.$el.hasClass("tile-error-message-common")) {
      var $errorMessageKey = _self.$el.find('.js-error-message-key');
      var $userErrorMessage = _self.$el.find('.js-user-error-message');
      if($errorMessageKey.length>0 || $userErrorMessage.length>0) {
        _self.$el.removeClass("is-hidden");
      }
    }
  }
}));
